import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue via-blue to-blue/90 flex items-center justify-center p-4 font-poppins">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-20 w-96 h-96 bg-yellow/10 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-20 right-20 w-80 h-80 bg-white/5 rounded-full blur-3xl animate-pulse delay-1000" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-yellow/5 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 w-full max-w-lg">
        {/* Main card */}
        <div className="bg-white/10 backdrop-blur-xl rounded-3xl border border-white/20 shadow-2xl p-8 md:p-10">
          {/* 404 Number */}
          <div className="flex justify-center mb-6">
            <div className="relative">
              <div className="text-[120px] md:text-[150px] font-bold text-white/10 leading-none select-none">
                404
              </div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-20 h-20 bg-yellow/20 rounded-full flex items-center justify-center">
                  <i className="fa-solid fa-map-location-dot text-4xl text-yellow" />
                </div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="text-center mb-8">
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-3">
              Page Not Found
            </h1>
            <p className="text-white/70 text-base leading-relaxed">
              Oops! The page you're looking for doesn't exist or has been moved. Let's get you back on track.
            </p>
          </div>

          {/* Suggestions */}
          <div className="bg-white/5 rounded-2xl border border-white/10 p-4 mb-8">
            <p className="text-white/90 text-sm font-medium mb-3">What you can try:</p>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-white/60 text-sm">
                <i className="fa-solid fa-check text-yellow text-xs" />
                Check the URL for any typos
              </li>
              <li className="flex items-center gap-2 text-white/60 text-sm">
                <i className="fa-solid fa-check text-yellow text-xs" />
                Go back to the previous page
              </li>
              <li className="flex items-center gap-2 text-white/60 text-sm">
                <i className="fa-solid fa-check text-yellow text-xs" />
                Return to the homepage
              </li>
            </ul>
          </div>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={() => navigate(-1)}
              className="flex-1 px-6 py-3 bg-white/10 hover:bg-white/20 border border-white/20 text-white font-semibold rounded-xl transition-all duration-200 flex items-center justify-center gap-2"
            >
              <i className="fa-solid fa-arrow-left text-sm" />
              Go Back
            </button>
            <button
              onClick={() => navigate("/")}
              className="flex-1 px-6 py-3 bg-yellow hover:bg-yellow/90 text-blue font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 flex items-center justify-center gap-2"
            >
              <i className="fa-solid fa-home text-sm" />
              Go to Homepage
            </button>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-6 text-center">
          <p className="text-white/40 text-sm">
            Lost?{" "}
            <button
              onClick={() => navigate("/")}
              className="text-yellow hover:text-yellow/80 font-medium transition-colors"
            >
              Track a shipment
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
